module.exports = __webpack_public_path__ + "static/media/cookie4-angle.3da538e0.png";